import {BaseModel} from "./BaseModel";
import angular from "angular";

export class ExtraLabelModel extends BaseModel {

     /**
     * @param {object} initializer - {
     * }
     */
    constructor(initializer) {
        let init = (initializer) ? angular.copy(initializer) : {};
        let required =  [];
        super(required, init);
    }

    serialize() {
        let serialized = super.serialize();
        return Object.assign(serialized, {
            'language': 'Language preference',
            'csr_initials': 'Customer Service Rep initials',
            'spouse_first_name': 'Spouse first name',
            'spouse_last_name': 'Spouse last name',
            'spouse_birth_date': 'Spouse birth date',
            'spouse_age': 'Spouse age',
            'permission_to_call': 'Permission to call',
            'permission_to_leave_message': 'Permission to leave message',
            'best_time_to_call': 'Best time to call',
            'how_did_you_hear': 'How did you hear about us',
            'policy_holder': 'Policy holder',
            'policy_number': 'Policy number',
            'cost_to_agent': 'Cost to Agent',
            'spouse_policy_number': 'Spouse/Household Policy Number',
            'comments': 'Comments'
        });
    }
}

export class ExtraLabelService {

    constructor() { }

    newModel(initializer) {
        return new ExtraLabelModel(initializer);
    }
}



// WEBPACK FOOTER //
// ./app/jangl/ExtraLabelService.js